/* eslint-disable react/no-unescaped-entities */
function Sections() {
  const sections = [
    {
      sectionName: "Overview",
      questions: [
        {
          question: "",
          answer: (
            <span>
              <p>
                Aevo is a distributed set of specially developed smart contracts
                (each, a “Smart Contract”) deployed on the Ethereum main-chain
                network alongside a customized Layer 2 EVM rollup (each, the
                “relevant Blockchain Network”) which allows any user to buy or
                sell cryptocurrency derivatives (including options and perpetual
                futures) directly in a peer-to-peer manner. Aevo offers a
                variety of features necessary for sophisticated derivatives
                traders, such as different order types, portfolio margin
                trading, trading via API keys, a wide variety of instruments
                with multiple strikes and expiries, as well as deep liquidity
                for trades.
              </p>
              <p>
                The Smart Contracts may be visualized on a user interface that
                the user can interact with, including but not limited to the
                website at https://www.aevo.xyz/ and each of their subdomains,
                or our mobile or web applications (the “Site”). Aevo is a
                decentralized non-custodial exchange which utilizes a
                centralized order book and matching engine. The Smart Contracts,
                the order book, the matching engine, computational/storage
                resources, the Site, and any other tools or software available
                on the Site are collectively referred to in these Terms as (the
                “App”). Using the App, users can interact with the underlying
                Smart Contracts to view their portfolio, buy, or sell
                cryptocurrency derivatives, view their historical transactions,
                and deposit to or withdraw from the Smart Contracts.
              </p>
              <p>
                Ribbon Technologies LLC (SVG) (the “Company”, “we”, “our”, or
                “us”) is making the App available to you. Before you use the App
                or the Site, however, you will need to agree to these Terms of
                Use and any terms and conditions incorporated herein by
                reference (collectively, these “Terms”). PLEASE READ THESE TERMS
                CAREFULLY BEFORE USING THE APP OR THE SITE. THESE TERMS GOVERN
                YOUR USE OF THE APP AND THE SITE, UNLESS WE HAVE EXECUTED A
                SEPARATE WRITTEN AGREEMENT WITH YOU FOR THAT PURPOSE. WE ARE
                ONLY WILLING TO MAKE THE APP AND THE SITE AVAILABLE TO YOU IF
                YOU ACCEPT ALL OF THESE TERMS. BY USING THE APP, THE SITE, OR
                ANY PART OF THEM, OR BY CLICKING “I ACCEPT” BELOW OR INDICATING
                YOUR ACCEPTANCE IN AN ADJOINING BOX, YOU ARE CONFIRMING THAT YOU
                UNDERSTAND AND AGREE TO BE BOUND BY ALL OF THESE TERMS. IF YOU
                ARE ACCEPTING THESE TERMS ON BEHALF OF A COMPANY OR OTHER LEGAL
                ENTITY, YOU REPRESENT THAT YOU HAVE THE LEGAL AUTHORITY TO
                ACCEPT THESE TERMS ON THAT ENTITY’S BEHALF, IN WHICH CASE “YOU”
                WILL MEAN THAT ENTITY. IF YOU DO NOT HAVE SUCH AUTHORITY, OR IF
                YOU DO NOT ACCEPT ALL OF THESE TERMS, THEN WE ARE UNWILLING TO
                MAKE THE APP OR THE SITE AVAILABLE TO YOU. IF YOU DO NOT AGREE
                TO THESE TERMS, YOU MAY NOT ACCESS OR USE THE APP OR THE SITE.
              </p>
              <p>
                Supplemental terms and conditions or documents that may be
                posted on the App from time to time are hereby expressly
                incorporated herein by reference. We reserve the right, in our
                sole discretion, to make changes to the Terms from time to time.
                We will alert you of any changes by updating the “Last Updated”
                date of these Terms (on the last page hereof), and you waive any
                right to receive specific notice of each such change. It is your
                responsibility to periodically review these Terms to stay
                informed of updates. You will be subject to and will be deemed
                to have been made aware of and to have accepted, the changes in
                any revised Terms by your continued use of the Site and the App
                after the date such revised Terms are posted.
              </p>
            </span>
          ),
        },
        {
          question: "1. Introduction",
          answer: (
            <span>
              <p>
                1.1. To be eligible to use the Site, the App and the Services
                (as defined below), you must be of legal age to enter into these
                Terms where you live and have the legal capacity to enter into
                these Terms. The Site, the App and the Services are strictly NOT
                offered to persons or entities who reside in, are citizens of,
                are incorporated in, or have a registered office in any
                Restricted Territory, as defined below (any such person or
                entity from a Restricted Territory shall be a Restricted
                Person). If you are a Restricted Person, then do not attempt to
                access or use the Site, the App or the Services. Use of a
                virtual private network (e.g., a VPN) or other means by
                Restricted Persons to access or use the Site, the App or the
                Services is prohibited.
              </p>
              <p>
                For the purpose of these Terms, Restricted Territory shall mean
                Singapore, Saint Vincent and the Grenadines, the United States
                of America, Canada, the United Kingdom and the People's Republic
                of China, Belarus, Cuba, Democratic People's Republic of Korea
                (DPRK), Democratic Republic of Congo, Iran, Lebanon, Libya,
                Mali, Myanmar, Nicaragua, Russia, Somalia, South Sudan, Sudan,
                Syria, Yemen, Zimbabwe, Russia, the following regions of
                Ukraine: Crimea, Donetsk and Luhansk, or any other country or
                region that is the subject of comprehensive country-wide or
                region-wide or economic sanctions by the United Nations, United
                States of America, the European Union or the United Kingdom; and
                (b) United States of America, the United Kingdom, Canada, and
                the People’s Republic of China. If you are a resident or citizen
                of or otherwise are located or incorporated in, or have a
                registered office in any Restricted Territory, do not use the
                Site, the App or the Services or attempt to use a virtual
                private network (VPN) or other technology to circumvent the
                restrictions set forth herein. Use of a VPN to access the Site,
                the App or the Services is expressly prohibited. You acknowledge
                and agree that you will not use a VPN or similar technology to
                access or use the Site, the App or the Services in any way. We
                reserve the right to restrict or discontinue your access to and
                use of the Site, the App or the Services if we know or have
                reason to suspect you are using a VPN for such access or use.
              </p>
              <p>
                1.2 The Site or the App or the Services made available through
                the App (or any portion thereof) may not be available to all
                users, and we reserve the right to assess or reassess at any
                time your eligibility to use all or part of the Site or the App.
              </p>
              <p>
                1.3 The Site, the App and the Services do not constitute, and
                may not be used for the purposes of, an offer or solicitation to
                anyone in any jurisdiction in which such offer or solicitation
                is not authorized, or to any person to whom it is unlawful to
                make such an offer or solicitation.
              </p>
              <p>
                1.4 Without limiting the foregoing, by using the Site, the App
                and the Services, you acknowledge and understand that laws
                regarding digital assets, cryptocurrency derivatives, financial
                instruments, or investment products which may include digital
                assets, may vary from jurisdiction to jurisdiction, and it is
                your sole obligation to ensure that you fully comply with any
                law, regulation or directive, relevant to your jurisdiction with
                regard to the use of the Site and the App. For the avoidance of
                doubt, the ability to access the Site or the App does not
                necessarily mean that the same (or your activities through it)
                are legal under the laws, regulations, or directives relevant to
                your jurisdiction.
              </p>
            </span>
          ),
        },
        {
          question: "2. The App",
          answer: (
            <span>
              <p>
                2.1. To most easily access the App, you may first install a web
                browser (such as the Google Chrome web browser) and an
                electronic wallet compatible with the relevant Blockchain
                Network (such as the Metamask, WalletConnect or Coinbase
                electronic wallet). These electronic wallet services provide a
                visual representation allowing you to interact with the relevant
                Blockchain Network to purchase, store, and engage in
                transactions with various digital assets. You will not be able
                to engage in any transactions on the App other than through your
                selected electronic wallet service, or other browsers compatible
                with the relevant Blockchain Network.
              </p>
              <p>
                2.2. Transactions that take place via the visual user interface
                on the App are confirmed via the relevant Blockchain Network.
                You understand that your public address on the relevant
                Blockchain Network will be made publicly visible whenever you
                engage in a transaction on the App.
              </p>
              <p>
                2.3. Aevo is a non-custodial protocol, therefore the App does
                not hold or control your digital assets. Any digital assets
                which you may acquire through the usage of the App will be held
                and administered solely by you through your selected electronic
                wallet, and we shall have no access to or responsibility in
                regard to such electronic wallet or digital asset held therein.
                It is solely your responsibility to select the wallet service
                provider to use in connection with the App, and your use of such
                electronic wallet will be subject to the governing terms of use
                or privacy policy of the provider of such wallet. We neither own
                nor control your selected electronic wallet service, Google
                Chrome, any electronic wallet, the relevant Blockchain Network,
                or any other third-party site, product, or service that you
                might access, visit, or use for the purpose of enabling you to
                use the various features of the App. We will not be liable for
                the acts or omissions of any such third parties, nor will we be
                liable for any damage that you may suffer as a result of your
                transactions or any other interaction with any such third
                parties.
              </p>
              <p>
                2.4. The Company will not create any hosted wallet for you or
                otherwise custody digital assets on your behalf, and it is your
                sole responsibility to maintain the security of your selected
                electronic wallet. In the event that you lose access to your
                electronic wallet, private key(s), password(s), or other
                method(s) of securing your Wallet, all digital assets held in
                such wallet may be irretrievable, and the Company will be unable
                to assist you in any way. You hereby irrevocably waive, release
                and discharge all claims, whether known or unknown to you,
                against the Company, its affiliates and their respective
                shareholders, members, directors, officers, employees, agents
                and representatives related to your use of any wallet software,
                associated loss of digital assets, transaction failures, or any
                other defects that arise in the course of your use of your
                electronic wallet, including any losses that may obtain as a
                result of any failure of the Site or the App.
              </p>
              <p>
                2.5. The Company reserves the right to modify, suspend or
                discontinue, temporarily or permanently, all or any part of the
                Site or the App with or without notice. You agree that the
                Company will not be liable to you or to any third party for any
                modification, suspension or discontinuance of all or any part of
                the Site or the App.
              </p>
              <p>
                2.6. The publicly deployed Smart Contracts you interact with are
                experimental in nature and you should not utilize the App for
                deployment of any substantial amount of digital assets.
              </p>
              <p>
                2.7. We reserve the right to disable access (including to only
                allow open positions to be closed) to the App, the Site or the
                interface at any time in the event of any breach of the Terms,
                including without limitation, if we, in our sole discretion,
                believe that you, at any time, fail to satisfy the eligibility
                requirements set forth in the Terms. Further, we reserve the
                right to limit or restrict access to the App or the Site by any
                person or entity, or within any geographic area or legal
                jurisdiction, at any time and at our sole discretion. We will
                not be liable to you for any losses or damages you may suffer as
                a result of or in connection with the App or the Site being
                inaccessible to you at any time or for any reason.
              </p>
            </span>
          ),
        },
        {
          question: "3. Services",
          answer: (
            <span>
              <p>
                3.1. The Company has deployed the Smart Contracts on the
                relevant Blockchain Network for users to utilize in accordance
                with these Terms. Aevo operates based on a centralized order
                book, with confirmed trades recorded on the relevant Blockchain
                Network.
              </p>
              <p>
                3.2. Aevo allows users to buy or sell cryptocurrency derivatives
                directly in a peer-to-peer manner. The cryptocurrency
                derivatives available on Aevo generally comprise two main
                categories:
              </p>
              <p>
                (a) Options, which are contracts that allow the holder the right
                to buy (Call Option) or right to sell (Put Option) the
                underlying digital asset at a specified strike price on a
                specified expiry date (European-style), whereby in-the-money
                options are settled on expiry by payment of the relevant amount
                of digital asset (and not settled by physical delivery).
              </p>
              <p>
                (b) Perpetual Contracts, which are contracts to buy or sell the
                underlying digital asset at an unspecified specified time in the
                future (subject to rules around market disruptions and early
                settlement), whereby funding payments are periodically exchanged
                upon the expiry of each funding period between holders of the
                two sides of the contracts (long and short), with the direction
                and magnitude of the settlement based on the difference between
                the contract price and that of the underlying digital asset.
              </p>
              <p>
                3.3. Users may view the bid/offer orders on the Aevo centralized
                order book and place the relevant buy or sell orders. Users are
                able to enter multiple bids and offers, observe, or receive bids
                and offers entered by other users, and transact on such bids and
                offers. All bids and offers on the order book shall be firm
                orders (i.e., firm bids or offers and not indications of
                interest or indicative quotes), and all orders shall be
                displayed on the order book on an anonymous basis. Once there is
                a matching bid/offer, the trade will be irrevocably confirmed.
                Confirmed trades will be batched and recorded on the relevant
                Blockchain Network, whereby users would exchange the underlying
                digital asset or cryptocurrency derivatives to settle each
                trade. All trades conducted via Aevo would be performed in a
                non-custodial manner and users would remain in control of their
                digital assets.
              </p>
              <p>
                3.4. All interactions between users, traders, and market makers
                on Aevo operate in a peer-to-peer manner. When users “deposit”
                digital assets on the Layer 1 Smart Contracts of the relevant
                Blockchain Network, this represents a transaction whereby the
                user would place certain digital assets into the Smart Contracts
                together with a legal guarantee that these will be utilized to
                settle matched trades of cryptocurrency derivatives (which occur
                on the Layer 2 Smart Contracts); conversely when users
                “withdraw” digital assets, this represents a transaction whereby
                the users receives digital assets from the Layer 1 Smart
                Contracts (after netting/settling all associated profits/losses
                from buying or selling cryptocurrency derivatives on the Layer 2
                Smart Contracts). The users enter into a direct contractual
                relationship via the autonomous Smart Contracts and/or other
                smart contracts deployed by various other third-party networks,
                and therefore traders wholly assume all responsibility towards
                the contractual counterparty to the derivatives trade. There is
                no further control by or interaction with the Company (or the
                relevant affiliate) which had deployed the App or the Site. The
                Company and its affiliates shall in no circumstances be
                construed as a party to said peer-to-peer direct contractual
                relationship, is not liable for performance of obligations
                thereunder, nor does it bear any financial or commercial risk or
                provide any warranties or assurances in connection with the
                same.
              </p>
              <p>
                3.5. The App provides a visual user interface allowing users to
                buy or sell cryptocurrency derivatives directly with other users
                and does not act as an agent for any of the users. Although the
                App is intended to display accurate and timely order book
                information, the App or relevant tools/information may not
                always be entirely accurate, complete, or current and may also
                include technical inaccuracies or typographical errors. The
                pricing information data provided through the App does not
                represent an offer, a solicitation of an offer, or any advice
                regarding, or recommendation to enter into, a transaction with
                the Company or the App. Accordingly, users should verify all
                information before relying on it, and all decisions based on
                information contained on the App or tools/information tools are
                at the sole responsibility of each user.
              </p>
              <p>
                3.6. For each crypto derivatives position or trade taken out by
                the user, the trading rules would require the user to maintain a
                minimum outstanding amount of margin (in the relevant digital
                assets) in the underlying Smart Contracts. If the available
                digital assets fall below such minimum margin amounts, then the
                user's positions will be incrementally closed against the
                then-available prices in the order book until the remaining
                digital assets are sufficient for the remainder of the user's
                positions, in each case in accordance with the applicable
                trading rules for the relevant cryptocurrency derivative. Where
                there are no available orders in the order book for
                liquidations, the position would be taken over by the Aevo
                mutual cover scheme.
              </p>
              <p>
                3.7. Notwithstanding any of the other provisions in these Terms,
                any photographs, graphic illustrations, videos, models, charts,
                designs, or examples on the site are strictly for information
                purposes only and have no contractual value nor do they form the
                basis of any contract with the Company.
              </p>
              <p>
                3.8. Neither the Company, the Site nor the App provides any
                digital asset exchange or portfolio/fund management services
                (whether in connection with any cryptocurrency derivatives or
                otherwise). If you choose to engage in transactions relating to
                cryptocurrency derivatives with other users, then such decisions
                and transactions and any consequences flowing therefrom are your
                sole responsibility. In no event shall the Company, its
                affiliates or their respective directors or employees be
                responsible or liable to you or anyone else, directly or
                indirectly, for any damage or loss arising from or relating to
                any interaction or continued interaction with cryptocurrency
                derivatives, or reliance on any information provided on the Site
                or the App (including, without limitation, directly or
                indirectly resulting from errors in, omissions of or alterations
                to any such information).
              </p>
              <p>
                3.9. THE APP SOLELY FUNCTIONS AS A VISUAL USER INTERFACE. IN NO
                CIRCUMSTANCES SHALL THE COMPANY, THE SITE OR THE APP BE
                CONSTRUED AS A DIGITAL ASSET EXCHANGE, BROKER, DEALER, FUND
                MANAGER, FINANCIAL INSTITUTION, EXCHANGE, CUSTODIAN,
                ROBO-ADVISOR, INTERMEDIARY, OR CREDITOR. THE SITE DOES
                FACILITATE OR ARRANGE TRANSACTIONS BETWEEN BUYERS AND SELLERS
                WITH RESPECT TO TRANSACTIONS THAT OCCUR IN CONNECTION WITH
                CRYPTOCURRENCY DERIVATIVES, WHICH TRANSACTIONS OCCUR ON THE
                RELEVANT BLOCKCHAIN NETWORK. THE COMPANY IS NOT A COUNTERPARTY
                TO ANY TRANSACTION FACILITATED BY THE SITE OR THE APP OR FOR ANY
                USER OF THE SITE. NEITHER THE SITE OR THE APP PROVIDES FINANCIAL
                ADVISORY, LEGAL, REGULATORY, OR TAX SERVICES DIRECTLY,
                INDIRECTLY, IMPLICITLY, OR IN ANY OTHER MANNER, AND YOU SHOULD
                NOT CONSIDER ANY CONTENT CONTAINED IN THESE TERMS OR OTHERWISE
                POSTED ON THE SITE TO BE A SUBSTITUTE FOR PROFESSIONAL
                FINANCIAL, LEGAL, REGULATORY, TAX OR OTHER ADVICE. THE COMPANY
                DOES NOT SUPPORT OR ENDORSE ANY CRYPTOCURRENCY DERIVATIVE
                PRODUCT, AND EACH USER IS AN INDEPENDENT AGENT WITH NO
                EMPLOYMENT OR OTHER CONTRACTUAL RELATIONSHIP WITH THE COMPANY.
              </p>
              <p>
                3.10. The Company reserves the right to suspend or terminate
                access to the Site or the App by any user for any reason
                whatsoever (including without limitation for a breach of these
                Terms). You agree that the Company will not be liable to you or
                to any third party for any suspension or termination of any
                user.
              </p>
              <p>
                3.11. Access to the App or the Site may become degraded or
                unavailable during times of significant volatility or volume.
                This could result in the inability to interact with third-party
                services for periods of time and may also lead to support
                response time delays. The Company cannot guarantee that the App
                or the Site will be available without interruption and neither
                do we guarantee that requests to interact with third-party
                services will be successful.
              </p>
            </span>
          ),
        },
        {
          question: "4. Fees and Payment",
          answer: (
            <span>
              <p>
                4.1. If you elect to buy or sell cryptocurrency derivatives, all
                transactions will be conducted solely through the relevant
                Blockchain Network. We will have no insight into or control over
                these payments or transactions, nor do we have the ability to
                reverse any transactions. With that in mind, we will have no
                liability to you or to any third party for any claims or damages
                that may arise as a result of any transactions that you engage
                in via the App, or any other transactions that you conduct via
                the relevant Blockchain Network.
              </p>
              <p>
                4.2. The relevant Layer 1 Blockchain Network typically requires
                the payment of a transaction fee (a "Gas Fee") for every
                transaction that occurs on such network, including all bridge
                transactions to/with the Layer 2 Blockchain Network. The Gas Fee
                funds the network of computers that run the decentralised
                network for the Layer 1 Blockchain Network. However, there are
                no Gas Fees payable for transactions (e.g. trades) that occur on
                the Layer 2 Blockchain Network.
              </p>
              <p>
                4.3. You may be subject to certain additional fees and
                commissions for the Services, as notified to you prior to
                submitting any buy or sell order for cryptocurrency derivatives.
                The Company also reserves the right to levy additional fees for
                access via the Site or the App in the future. You agree to
                promptly pay all aforementioned fees and commissions.
              </p>
              <p>
                4.4. Notwithstanding anything in these Terms to the contrary,
                you will be solely responsible to pay any and all sales, use,
                value-added and other taxes, duties, and assessments (except
                taxes on our net income) now or hereafter claimed or imposed by
                any governmental authority (collectively, "Taxes") associated
                with your use of the App (including, without limitation, any
                Taxes that may become payable as the result of buying or selling
                cryptocurrency derivatives or interaction with the Site, the App
                or Aevo).
              </p>
            </span>
          ),
        },
        {
          question: "5. Intellectual Property and Content",
          answer: (
            <span>
              <p>
                5.1. The Company owns the Site and the App. You acknowledge and
                agree that the Company (or, as applicable, its affiliates) owns
                all legal right, title and interest in and to all other elements
                of the site and the App, and all intellectual property rights
                therein (including, without limitation, all designs, systems,
                methods, information, computer code, software, services, website
                design, "look and feel", organisation, compilation of the
                content, code, data and database, functionality, audio, video,
                text, photograph, graphics, copyright, trademarks (if any), and
                all other elements of the App (collectively, the "Materials").
                You acknowledge that the Materials are protected by copyright,
                trade dress, patent, and trademark laws, international
                conventions, other relevant intellectual property and
                proprietary rights, and applicable laws. All Materials are the
                copyrighted property of The Company or its licensors, and all
                trademarks, service marks, and trade names associated with the
                App or otherwise contained in the Materials are proprietary to
                The Company or its licensors. Except as expressly set forth
                herein, your use of the App does not grant you ownership of or
                any other rights with respect to any content, code, data, or
                other Materials that you may access on or through the App. We
                reserve all rights in and to the Materials that are not
                expressly granted to you in these Terms. For the sake of
                clarity, you understand and agree: that (a) your usage of the
                Site or the App does not give you any rights or licenses in or
                to the Materials other than those expressly contained in these
                Terms; (b) you do not have the right to license, sell, rent,
                lease, transfer, assign, distribute, host, reproduce,
                distribute, or otherwise commercialise any elements of the
                Materials without our prior written consent in each case, which
                consent we may withhold in our sole and absolute discretion; (c)
                you shall not modify, make derivative works of, disassemble,
                reverse compile or reverse engineer any part of the Materials;
                and (d) you will not apply for, register, or otherwise use or
                attempt to use any of the Company's trademarks or service marks,
                or any confusingly similar marks, anywhere in the world.
              </p>
              <p>
                5.2. By interacting with the Site and the App, you are granted a
                limited, non-exclusive, non-transferable, revocable license to
                use the Site and the App for your personal use. Neither these
                Terms nor your access to the Site and the App transfers to you
                or any third party any rights, title or interest in or to
                intellectual property rights in the Materials, except for the
                limited access rights expressly set forth in these Terms. The
                Company expressly reserves all rights not granted in these
                Terms. There are no implied licenses granted under these Terms.
              </p>
              <p>
                5.3. By acceptance of these Terms, you agree and acknowledge
                that all information and content provided by you, including your
                username, your contact list, transaction history, any messages,
                posts, comments, profit-and-loss cards/summaries, or user
                generated content (the "UGC") in any communication channel
                (including without limitation Twitter, Discord or Telegram)
                shall be considered non-confidential and non-proprietary
                information. By providing such UGC, you specifically grant the
                Company a non-exclusive, irrevocable, transferable,
                sub-licensable, royalty-free, worldwide license to use, copy,
                duplicate store, present and publish all or any part of the UGC,
                and the Company shall be free to use such UGC in any manner or
                media whatsoever, on an unrestricted basis and without any
                attribution or royalties or other compensation to you,
                including, without limitation, within or outside the Site or the
                App, and in any digital or printed media.
              </p>
              <p>
                5.4. You acknowledge that you shall be responsible for any UGC
                that you submit or transmit through the Site or the App,
                including your responsibility as to the legality, reliability,
                appropriateness, originality and copyright of any such
                information or material. Additionally, you represent and warrant
                that: (a) you own all right title and interest in any UGC
                provided by you, (b) such UGC does not violate any applicable
                laws, and (c) the posting of your UGC by us (in any manner or
                media whatsoever, on an unrestricted basis) does not (and will
                not) violate the privacy rights, publicity rights, copyright,
                contract rights or any other rights of any individual or make
                derogatory remarks regarding, defame or otherwise criticise any
                person or entity. You shall be solely liable for any damage
                resulting from any infringement or other violation of the
                copyright, trademarks or other proprietary rights of any
                individual or entity, and for any other harm or losses resulting
                from any UGC.
              </p>
              <p>
                5.5. You acknowledge and agree that any questions, comments,
                suggestions, ideas, feedback or other information regarding the
                Site and the App ("Feedback") provided by you to us are
                non-confidential and should become our sole property. We should
                own exclusive rights, including all intellectual property
                rights, and should be entitled to the unrestricted use and
                dissemination of these Feedback to any lawful purpose,
                commercial, or otherwise, without acknowledgment or compensation
                for you. You hereby waive any moral rights to any such Feedback,
                and you hereby warrant that any such Feedback are original with
                you or that you have the right to submit such Feedback. You
                agree there should be no recourse against us for any alleged or
                actual infringement or misappropriation of any proprietary right
                in your Feedback.
              </p>
            </span>
          ),
        },
        {
          question: "6. User Terms",
          answer: (
            <span>
              <p>
                6.1. You agree that you are responsible for your own conduct
                while accessing or using the App, and for any consequences
                thereof. You agree to use the App only for purposes that are
                legal, proper and in accordance with these Terms and any
                applicable laws or regulations (including, without limitation,
                data privacy and protection laws, anti-money laundering,
                anti-terrorism, anti-corruption, export control and economic
                sanctions laws and regulations), including without limitation
                you may not: (a) send, upload, distribute or disseminate any
                unlawful, defamatory, harassing, abusive, fraudulent, obscene,
                or otherwise objectionable content; (b) distribute viruses,
                worms, defects, Trojan horses, corrupted files, hoaxes, or any
                other items of a destructive or deceptive nature; (c)
                impersonate another person (via the use of an email address or
                otherwise); (d) upload, post, transmit or otherwise make
                available through the App any content that infringes the
                intellectual proprietary rights of any party; (e) use the App to
                violate the legal rights (such as rights of privacy and
                publicity) of others; (f) engage in, promote, or encourage
                illegal activity (including, without limitation, money
                laundering); (g) interfere with other users' enjoyment of the
                App; (h) exploit the App for any unauthorized commercial
                purpose; (i) modify, adapt, translate, decompile, disassemble or
                reverse engineer any portion of the App; (j) attempt to bypass
                any measure of the Site designed to prevent or restrict access
                to the Site, or any portion of the Site or the App; (k) harass,
                intimidate, or threaten any of our employees or agents engaged
                in providing any portion of the Site or the App to you; (l)
                remove any copyright, trademark or other proprietary rights
                notices contained in or on the App, the Contents or any part of
                it; (m) reformat or frame any portion of the App; (n) display
                any content on the App that contains any hate-related or violent
                content or contains any other material, products or services
                that violate or encourage conduct that would violate any
                criminal laws, any other applicable laws, or any third party
                rights; (o) use any robot, spider, site search/retrieval
                application, or other device to retrieve or index any portion of
                the App or the content posted on the App, or to collect
                information about its users for any unauthorized purpose; (p)
                upload or transmit (or attempt to upload or to transmit) any
                material that acts as a passive or active information collection
                or transmission mechanism, including without limitation, clear
                graphics interchange formats (“gifs”), 1×1 pixels, web bugs,
                cookies, or other similar devices (sometimes referred to as
                “spyware” or “passive collection mechanisms” or “pcms”); (q)
                access or use the App by automated means or under false or
                fraudulent pretenses; (r) access or use the App for the purpose
                of creating a product or service that is competitive with any of
                our products or services; (s) use the Site and the App to
                advertise or offer to sell goods and services; (t) conduct any
                activity that violates any applicable law, rule, or regulation
                concerning the integrity of trading markets, including (but not
                limited to) the manipulative tactics commonly known as spoofing,
                wash trading, cornering, accommodation trading, fictitious
                transactions, “money pass” (i.e. transactions without a net
                change in either party's open positions but with a resulting
                profit to one party and a loss to the other party), or
                pre-arranged or non-competitive transactions, (u) disparage,
                tarnish, or otherwise harm, in our opinion, us and/or the Site
                and the App, or (v) use the Site, the App or the Services if you
                are (A) identified as a “Specially Designated National” by the
                US Office of Foreign Assets Control or otherwise subject to any
                sanctions or restrictions which may affect our ability to
                provide you with our Services, or (B) located in, or a resident
                of, any Restricted Territory or have used any technical means
                (including a VPN) to misrepresent your geographical location. If
                you engage in any of the activities prohibited by this Section
                6, we may, at our sole and absolute discretion, without notice
                to you, and without limiting any of our other rights or remedies
                at law or in equity, immediately suspend or terminate your
                access to the Site or the App and delete your UGC from the Site.
              </p>
              <p>
                6.2. By using the Site and the App, you represent and warrant
                that: (a) you have read and understood these Terms and all
                documentation on the App or the Site; (b) you have good and
                sufficient experience and understanding of the functionality,
                usage, storage, transmission mechanisms and other material
                characteristics of cryptographic tokens, token storage
                mechanisms (such as token wallets), blockchain technology,
                blockchain-like technology and blockchain-based software systems
                to understand these Terms and to appreciate the risks and
                implications of buying or selling cryptocurrency derivatives;
                (c) you acknowledge and agree that we may impose eligibility
                criteria to access certain functionality in respect of Aevo
                which may require you to incur additional time and money costs;
                (d) you buy and sell cryptocurrency derivatives for your own
                account and shall not do the same on behalf of any other entity
                or person; (e) your buying and selling of cryptocurrency
                derivatives complies with applicable law and regulation in your
                jurisdiction, and the law and regulation of any jurisdiction to
                which you may be subject (including, but not limited to legal
                capacity and any other threshold requirements for buying or
                selling cryptocurrency derivatives or interacting with other
                users of the App, any foreign exchange or regulatory
                restrictions applicable to buying or selling cryptocurrency
                derivatives, and any governmental or other consents that may
                need to be obtained); (f) all information you submit will be
                true, accurate, current, and complete (if you provide any
                information that is untrue, inaccurate, not current, or
                incomplete, we have the right to refuse or terminate your
                current or future use of the Site and the App (or any portion
                thereof)); (g) you will maintain the accuracy of such
                information and promptly update such information as necessary;
                (h) you have the legal capacity and you agree to comply with
                these Terms; (i) you are not a minor in the jurisdiction in
                which you reside; (j) you will not use the Site or the App for
                any illegal and unauthorized purpose; (k) you will not use the
                Site or the App for any commercial purpose (save as approved by
                the Company in writing); (l) your use of the Site and the App
                will not violate any applicable law or regulation; and (m) any
                funds or digital assets utilized to buy or sell cryptocurrency
                derivatives are not derived from or related to any unlawful
                activities, including but not limited to money laundering or
                terrorist financing and all applicable statutes of all
                jurisdictions in which you are located, resident, organized or
                operating, and/or to which it may otherwise be subject and the
                rules and regulations thereunder (collectively, the “Compliance
                Regulations”), and you will not use the Site or the App to
                finance, engage in, or otherwise support any unlawful activities
                or in a manner which aids or facilitates another party in the
                same. To the extent required by applicable laws and regulations,
                you shall fully comply with all Compliance Regulations.
              </p>
              <p>
                6.3. We reserve the right to conduct “Know Your Customer” and
                “Anti-Money Laundering” checks on you if deemed necessary by us
                (at our sole discretion) or such checks become required under
                applicable laws in any jurisdiction. Upon our request, you shall
                immediately provide us with information and documents that we,
                in our sole discretion, deem necessary or appropriate to conduct
                “Know Your Customer” and “Anti-Money Laundering” checks. Such
                documents may include, but are not limited to, passports,
                driver's licenses, utility bills, photographs of associated
                individuals, government identification cards or sworn statements
                before notaries or other equivalent professionals.
                Notwithstanding anything herein, we may, in its sole discretion,
                refuse to provide access to the Site or the Site to you until
                such requested information is provided, or in the event that,
                based on information available to us, you are suspected of using
                the Site or the App in connection with any money laundering,
                terrorism financing, or any other illegal activity. In addition,
                we shall be entitled to use any possible efforts for preventing
                money laundering, terrorism financing or any other illegal
                activity, including without limitation blocking of your access
                to the App or the Site or providing your information to any
                regulatory authority.
              </p>
              <p>
                6.4. You are responsible for complying with applicable laws
                (including tax laws) in connection with usage of the Site, the
                App, or other users. You agree that we are not responsible for
                determining whether or which laws may apply to said
                interactions. You are advised to consult your own lawyers
                regarding the legality and implications of any such activities.
                You are solely responsible for reporting and paying any taxes
                arising from your usage of the Site, the App or interactions
                with other users.
              </p>
            </span>
          ),
        },
        {
          question: "7. Risks borne by users",
          answer: (
            <span>
              <p>
                You acknowledge and agree that the Services, the Site and the
                App are currently in the initial development stages and there
                are a variety of unforeseeable risks with utilising the
                foregoing. In the worst scenario, this could lead to the loss of
                all or part of your digital assets interacting with the
                Services, the Site or the App. IF YOU DECIDE TO UTILISE SERVICES
                YOU EXPRESSLY ACKNOWLEDGE, ACCEPT AND ASSUME THE BELOW RISKS AND
                AGREE NOT TO HOLD THE COMPANY OR ANY OF THEIR AFFILIATES
                RESPONSIBLE FOR THE FOLLOWING RISKS:
              </p>
              <p>
                7.1. Using the App and/or buying or selling cryptocurrency
                derivatives carry financial risk. You acknowledge and agree that
                you are aware of such risks, including the following: (a)
                transactions relating to digital assets are very risky, and such
                digital assets are, by their nature, highly experimental, risky,
                volatile and generally irreversible. You should not make any
                transactional decision without first conducting your own
                research. You are solely and exclusively responsible for
                determining whether buying or selling cryptocurrency
                derivatives, any transaction, or strategy, or any other product
                or service in connection with the same is appropriate or
                suitable for you based on your own objectives and personal and
                financial situation. You acknowledge and agree that you will
                access and use the Site and the App and interact with other
                users at your own risk.
              </p>
              <p>
                7.2. You represent that you have sufficient knowledge, market
                sophistication, professional advice and experience to make your
                own evaluation of the merits and risks of buying or selling
                cryptocurrency derivatives. You accept all consequences of
                participating in such interactions, including the risk that you
                may lose access to your digital assets indefinitely. All
                decisions to buy or sell cryptocurrency derivatives are made
                solely by you. Notwithstanding anything in these Terms, the
                Company accepts no responsibility whatsoever for and will in no
                circumstances be liable to you in connection with any
                interaction with the Site or the App, or the purchase or sale of
                any cryptocurrency derivatives. Under no circumstances will the
                operation of all or any portion of the Site or the App be deemed
                to create a relationship that includes any management of any
                assets, or the provision or tendering of investment advice.
              </p>
              <p>
                7.3. Digital assets and cryptocurrency derivatives are not legal
                tender, are not backed by the government, and are not subject to
                any "Deposit Insurance Scheme" or protections under any banking
                or securities laws. The Company is not a bank and does not offer
                any lending services, fiduciary services, or security broking
                services.
              </p>
              <p>
                7.4. The prices of blockchain assets are extremely volatile.
                Fluctuations in the price of other digital assets could
                materially and adversely affect the value of cryptocurrency
                derivatives, which may also be subject to significant price
                volatility. We cannot guarantee that any user buying or selling
                cryptocurrency derivatives will not lose money.
              </p>
              <p>
                7.5. Neither the Site nor the App hold in custody, store, send,
                or receive any of your digital assets. This is because your
                digital assets exist only by virtue of the ownership record
                maintained on the relevant Blockchain Network. Any transfer of
                digital assets occurs within the relevant Blockchain Network,
                and not on the Site or the App.
              </p>
              <p>
                7.6. All smart contracts (including the Smart Contracts) may
                contain security vulnerabilities, errors, failures, bugs or
                economic loopholes which may be exploited by third parties,
                causing you to suffer losses in connection with any digital
                assets or bridged/wrapped assets utilised in connection with the
                Smart Contracts, the Site or the App. Interaction with the Site
                or the App are entirely at your own responsibility and
                liability, and the Company is not a party to the Smart
                Contracts. Further, when you interact with the App and place a
                buy or sell order, the trade will be irrevocably confirmed once
                there is a matching bid/offer and you will not be able to
                withdraw the buy or sell order.
              </p>
              <p>
                7.7. No party (including the Company) is able to guarantee the
                future performance of cryptocurrency derivatives, any specific
                level of performance, the success of any strategy or your
                overall results from buying or selling cryptocurrency
                derivatives. When reviewing the information, portfolio,
                performance, opinions of any party, do not assume that such
                party is unbiased, independent or qualified to provide financial
                information or opinions. Past performance and risk scores have
                many inherent limitations and are not indicative of future
                results. No representation or guarantee is being made that any
                cryptocurrency derivative will or is likely to achieve gains or
                losses similar to the past performance. The actual percentage
                gains or losses experienced by users will vary depending on many
                factors.
              </p>
              <p>
                7.8. Hackers or other malicious groups or organisations may
                attempt to interfere with the Site or the App in a variety of
                ways, including, but not limited to, malware attacks, denial of
                service attacks, consensus-based attacks, Sybil attacks,
                smurfing and spoofing. Furthermore, because the relevant
                Blockchain Network comprises open-source software, there is the
                software underlying the Services may contain intentional or
                unintentional bugs or weaknesses that may negatively affect the
                Services or the Smart Contracts, or result in the loss of the
                user’s original digital assets or bridged/wrapped assets, or the
                loss of the user’s ability to access or control their digital
                assets. In the event of such a software bug or weakness, there
                may be no remedy, and users are not guaranteed any remedy,
                refund or compensation.
              </p>
              <p>
                7.9. The regulatory status of original digital assets and
                bridged/wrapped assets, and distributed ledger technology is
                unclear or unsettled in many jurisdictions. While every effort
                has been taken to ensure that the Services, the Site and the App
                are compliant with local laws, it is difficult to predict how or
                whether regulatory agencies may apply existing regulation with
                respect to the same. It is likewise difficult to predict how or
                whether legislatures or regulatory agencies may implement
                changes to law and regulation affecting distributed ledger
                technology and its applications, including the Services, the
                Site or the App. Regulatory actions could negatively impact the
                Company in various ways, and thus the Services may not be
                available in certain areas.
              </p>
              <p>
                7.10. The underlying smart contracts run on a variety of
                supported blockchain networks, using specially-developed smart
                contracts. Accordingly, upgrades to the relevant Blockchain
                Network, a hard fork in the relevant Blockchain Network,
                re-organisations of blockchain structure or blocks, or a change
                in how transactions are confirmed on the relevant Blockchain
                Network may have unintended, adverse effects on the smart
                contracts built thereon, including the Smart Contract.
              </p>
              <p>
                7.11. The Site, Services and Smart Contracts may rely on or
                utilise a variety of external third party services or software,
                including without limitation Layer 2 infrastructure platforms
                (e.g. Conduit), cloud storage services (e.g. Amazon Web
                Services), analytics tools, oracles, hence therefore the
                Services may be adversely affected by any number of risks
                related to these third party services/software, which may be
                compromised in the event of security vulnerabilities,
                cyberattacks, malicious activity, or technical interruptions.
              </p>
              <p>
                7.12. You accept and confirm that a conflict of interest may
                arise when the interest of the Company and its affiliates
                competes or may appear to compete with your interests under
                these Terms. Specifically, you hereby acknowledge and confirm
                that: (a) the Company may participate in certain transactions in
                an individual capacity; (b) the Company may execute at the same
                time its own orders which may be opposite that of a user; (c)
                the Company may establish business, including without
                limitation, trading relationships with other ecosystem players,
                financial institutions, digital asset owners, digital asset
                exchanges, issuers of financial instruments and we may have a
                financial interest in such instruments; (d) the Company may seek
                to act as a market maker and in this context there may be
                inherent conflicts of interest; and (e) the Company may
                compensate or share its revenues from activities in connection
                with the Site or the App with various users, the Company's
                affiliates, partners or other similar parties.
              </p>
            </span>
          ),
        },
        {
          question: "8. External sites",
          answer: (
            <span>
              <p>
                The Site or the App may include hyperlinks to other web sites or
                resources (collectively, "External Sites"), which are provided
                solely for your convenience. We have no control over any
                External Sites. You acknowledge and agree that we are not
                responsible for the availability of any External Sites, and that
                we do not endorse any advertising, products or other materials
                on or made available from any External Sites. Furthermore, you
                acknowledge and agree that we are not liable for any loss or
                damage which may be incurred as a result of the availability or
                unavailability of the External Sites, or as a result of any
                reliance placed by you upon the completeness, accuracy or
                existence of any advertising, products or other materials on, or
                made available from, any External Sites.
              </p>
            </span>
          ),
        },
        {
          question: "9. Disclaimers",
          answer: (
            <span>
              <p>
                9.1. YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR ACCESS TO AND
                USE OF THE SITE AND THE APP IS AT YOUR SOLE RISK, AND THAT THE
                APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF
                ANY KIND, WHETHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT
                PERMISSIBLE PURSUANT TO APPLICABLE LAW, THE COMPANY, ITS
                SUBSIDIARIES, AFFILIATES, AND LICENSORS MAKE NO EXPRESS
                WARRANTIES AND HEREBY DISCLAIM ALL IMPLIED WARRANTIES REGARDING
                THE APP AND ANY PART OF IT (INCLUDING, WITHOUT LIMITATION, THE
                SITE, THE APP, THE SERVICES, OR ANY EXTERNAL WEBSITES),
                INCLUDING ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR
                A PARTICULAR PURPOSE, NON-INFRINGEMENT, CORRECTNESS, ACCURACY,
                OR RELIABILITY. WITHOUT LIMITING THE GENERALITY OF THE
                FOREGOING, THE COMPANY, ITS SUBSIDIARIES, AFFILIATES, AND
                LICENSORS DO NOT REPRESENT OR WARRANT TO YOU THAT: (A) YOUR
                ACCESS TO OR USE OF THE SITE AND THE APP WILL MEET YOUR
                REQUIREMENTS, (B) YOUR ACCESS TO OR USE OF THE SITE AND THE APP
                WILL BE UNINTERRUPTED, TIMELY, SECURE OR FREE FROM ERROR, (C)
                USAGE DATA PROVIDED THROUGH THE SITE OR THE APP WILL BE
                ACCURATE, (D) THE SITE AND THE APP, OR ANY CONTENT, SERVICES, OR
                FEATURES MADE AVAILABLE ON OR THROUGH THE SITE OR THE APP ARE
                FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR (E) THAT ANY
                DATA THAT YOU DISCLOSE WHEN YOU USE THE SITE OR THE APP WILL BE
                SECURE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED
                WARRANTIES IN CONTRACTS WITH CONSUMERS, SO SOME OR ALL OF THE
                ABOVE EXCLUSIONS MAY NOT APPLY TO YOU.
              </p>
              <p>
                9.2. IN PARTICULAR, YOU ACCEPT AND ACKNOWLEDGE THAT WHEN
                UTILISING THE APP OR THE SMART CONTRACTS, YOU ARE ENTERING INTO
                A DIRECT CONTRACTUAL RELATIONSHIP WITH THE CONTRACTUAL
                COUNTERPARTY TO THE DERIVATIVES TRADE. THE COMPANY AND ITS
                AFFILIATES SHALL IN NO CIRCUMSTANCES BE CONSTRUED AS A PARTY TO
                SAID PEER-TO-PEER DIRECT CONTRACTUAL RELATIONSHIP, IS NOT LIABLE
                FOR PERFORMANCE OF OBLIGATIONS THEREUNDER, NOR DOES IT BEAR ANY
                FINANCIAL OR COMMERCIAL RISK OR PROVIDE ANY WARRANTIES OR
                ASSURANCES IN CONNECTION WITH THE SAME. ACCORDINGLY, YOUR ONLY
                RECOURSE SHALL BE TOWARDS YOUR CONTRACTUAL COUNTERPARTY TO THE
                DERIVATIVES TRADE AND THE COMPANY CANNOT BE LIABLE FOR ANY
                LOSSES OR DAMAGE WHICH YOU SUFFER IN CONNECTION WITH THE SAME.
              </p>
              <p>
                9.3. YOU ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING
                INFORMATION AND DEALING ONLINE OVER THE INTERNET, AND AGREE THAT
                THE COMPANY HAS NO LIABILITY OR RESPONSIBILITY FOR ANY BREACH OF
                SECURITY UNLESS IT IS DUE TO THE COMPANY'S WILFUL DEFAULT.
              </p>
              <p>
                9.4. DIGITAL ASSETS ARE INTANGIBLE DIGITAL ASSETS THAT EXIST
                ONLY BY VIRTUE OF THE OWNERSHIP RECORD MAINTAINED IN THE
                RELEVANT BLOCKCHAIN NETWORK. ALL SMART CONTRACTS IN CONNECTION
                WITH AEVO ECOSYSTEM ARE DEPLOYED ON AND
                INTERACTIONS/TRANSACTIONS WITH THE SAME OCCUR ON THE
                DECENTRALISED LEDGER WITHIN THE RELEVANT BLOCKCHAIN NETWORK. WE
                HAVE NO CONTROL OVER AND MAKE NO GUARANTEES OR PROMISES WITH
                RESPECT TO SMART CONTRACTS.
              </p>
              <p>
                9.5. THE COMPANY IS NOT RESPONSIBLE FOR LOSSES DUE TO
                BLOCKCHAINS OR ANY OTHER FEATURES OF THE RELEVANT BLOCKCHAIN
                NETWORK OR YOUR SELECTED ELECTRONIC WALLET SERVICE, INCLUDING
                BUT NOT LIMITED TO LATE REPORT BY DEVELOPERS OR REPRESENTATIVES
                (OR NO REPORT AT ALL) OF ANY ISSUES WITH THE BLOCKCHAIN
                SUPPORTING THE RELEVANT BLOCKCHAIN NETWORK, INCLUDING FORKS,
                TECHNICAL NODE ISSUES, OR ANY OTHER ISSUES HAVING FUND LOSSES AS
                A RESULT.
              </p>
            </span>
          ),
        },
        {
          question: "10. Limitation of liability",
          answer: (
            <span>
              <p>
                10.1. YOU UNDERSTAND AND AGREE THAT WE, OUR SUBSIDIARIES,
                AFFILIATES, AND LICENSORS WILL NOT BE LIABLE TO YOU OR TO ANY
                THIRD PARTY FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
                CONSEQUENTIAL, OR EXEMPLARY DAMAGES WHICH YOU MAY INCUR IN
                CONNECTION WITH THE SITE, THE APP OR THE SERVICES, HOWSOEVER
                CAUSED AND UNDER ANY THEORY OF LIABILITY, INCLUDING, WITHOUT
                LIMITATION, ANY LOSS OF PROFITS (WHETHER INCURRED DIRECTLY OR
                INDIRECTLY), LOSS OF GOODWILL OR BUSINESS REPUTATION, LOSS OF
                DATA, COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR
                ANY OTHER INTANGIBLE LOSS, EVEN IF WE HAVE BEEN ADVISED OF THE
                POSSIBILITY OF SUCH DAMAGES.
              </p>
              <p>
                10.2. YOU AGREE THAT OUR TOTAL, AGGREGATE LIABILITY TO YOU FOR
                ANY AND ALL CLAIMS ARISING OUT OF OR RELATING TO THESE TERMS OR
                YOUR ACCESS TO OR USE OF (OR YOUR INABILITY TO ACCESS OR USE)
                ANY PORTION OF THE SITE, THE APP OR THE SERVICES, WHETHER IN
                CONTRACT, TORT, STRICT LIABILITY, OR ANY OTHER LEGAL THEORY, IS
                LIMITED TO THE GREATER OF (A) THE AMOUNTS YOU ACTUALLY PAID US
                UNDER THESE TERMS IN THE 12 MONTH PERIOD PRECEDING THE DATE THE
                CLAIM AROSE, OR (B) US$200.
              </p>
              <p>
                10.3. YOU ACKNOWLEDGE AND AGREE THAT WE HAVE MADE THE SITE, THE
                APP AND THE SERVICES AVAILABLE TO YOU AND ENTERED INTO THESE
                TERMS IN RELIANCE UPON THE WARRANTY DISCLAIMERS AND LIMITATIONS
                OF LIABILITY SET FORTH HEREIN, WHICH REFLECT A REASONABLE AND
                FAIR ALLOCATION OF RISK BETWEEN THE PARTIES AND FORM AN
                ESSENTIAL BASIS OF THE BARGAIN BETWEEN US. WE WOULD NOT BE ABLE
                TO PROVIDE THE APP TO YOU WITHOUT THESE LIMITATIONS.
              </p>
              <p>
                10.4. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR
                LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, AND SOME
                JURISDICTIONS ALSO LIMIT DISCLAIMERS OR LIMITATIONS OF LIABILITY
                FOR PERSONAL INJURY FROM CONSUMER PRODUCTS, SO THE ABOVE
                LIMITATIONS MAY NOT APPLY TO PERSONAL INJURY CLAIMS.
              </p>
            </span>
          ),
        },
        {
          question: "11. Indemnity",
          answer: (
            <span>
              <p>
                You agree to hold harmless and indemnify the Company and its
                subsidiaries, affiliates, officers, agents, employees,
                advertisers, licensors, suppliers or partners from and against
                any claim, liability, loss, damage (actual and consequential) of
                any kind or nature, suit, judgment, litigation cost, and
                attorneys' fees arising out of or in any way related to (a) your
                breach of these Terms, (b) your misuse of the Site, the App or
                the Services, or (c) your violation of any applicable laws,
                rules or regulations in connection with your access to or use of
                the App. You agree that the Company will have control of the
                defence or settlement of any such claims.
              </p>
            </span>
          ),
        },
        {
          question: "12. Privacy policy",
          answer: (
            <span>
              <p>
                12.1. The Company will maintain certain data that you transmit
                to the Site and the App for the purpose of managing the
                performance of the Site and the App, as well as data relating to
                your use of the Site or the App. Although we perform regular
                routine backups of data, the Company is solely responsible for
                all data that you transmit or that release to any activity you
                have undertaken using the Site or the App. You agree that we
                shall have no liability to you for any loss or corruption of any
                such data, and you hereby waive any right of action against us
                arising from any such loss or corruption of such data.
              </p>
            </span>
          ),
        },
        {
          question: "13. Consent to Electronic Disclosures and Signatures",
          answer: (
            <span>
              <p>
                13.1. Because the Company operates only on the Internet, it is
                necessary for you to consent to transact business with us online
                and electronically. As part of doing business with us,
                therefore, we also need you to consent to our providing you
                certain disclosures electronically via the Site. By agreeing to
                these Terms, you agree to receive electronically all documents,
                communications, notices, contracts, and agreements arising from
                or relating to your use of the Site and Services.
              </p>
              <p>
                13.2. By accepting these Terms or contacting us in any manner,
                you expressly consent to be contacted by us, our agents,
                representatives, affiliates, or anyone calling on our behalf for
                any and all purposes, in any way, including SMS messages
                (including text messages), calls using pre-recorded messages or
                artificial voice, and calls and messages delivered using an
                automatic telephone dialling system or an automatic texting
                system. Notwithstanding the aforementioned, any form of
                communication from the Company will be provided to you
                electronically through the Site or (if applicable) via email to
                the email address provided. If you require paper copies of any
                agreements or disclosures, you may print such documents desired.
              </p>
              <p>
                13.3. Your consent to receive disclosures and transact business
                electronically, and our agreement to do so, applies to any
                transactions to which such disclosures relate, whether between
                you and the Company or a third party by and through the
                Services. Your consent will remain in effect for so long as you
                are a user and, if you are no longer a user, will continue until
                such a time as all disclosures relevant to Services received
                through the Site.
              </p>
              <p>
                13.4. You may withdraw your consent to receive agreements or
                disclosures electronically by contacting us at
                admin@ribbonlabs.co. However, once you have withdrawn your
                consent you will not be able to access the Services or the Site.
              </p>
            </span>
          ),
        },
        {
          question: "14. Governing law and dispute resolution",
          answer: (
            <span>
              <p>
                14.1. These Terms will be governed by and construed in
                accordance with the laws of Saint Vincent and the Grenadines,
                without regard to conflict of law rules and principles (whether
                of Saint Vincent and the Grenadines or any other jurisdiction)
                that would cause the application of the laws of any other
                jurisdiction.
              </p>
              <p>
                14.2. All disputes arising out of or in connection with these
                Terms (including without limitation the enforceability of this
                Section 14 or any question regarding its existence, validity or
                termination, your access or use of the App, the Site or the
                Services) shall be referred to and finally resolved by
                arbitration administered in accordance with the BVI IAC
                Arbitration Rules for the time being in force, which rules are
                deemed to be incorporated by reference in this Section 14. The
                place of arbitration shall be Road Town, Tortola, British Virgin
                Islands, unless the Parties agree otherwise. The number of
                arbitrators shall be one. The language to be used in the
                arbitral proceedings shall be English. Each Party irrevocably
                submits to the jurisdiction and venue of such tribunal.
              </p>
              <p>
                14.3. The award of the arbitrator will be final and binding, and
                any judgment on the award rendered by the arbitrator may be
                entered in any court of competent jurisdiction. Each party will
                cover its own fees and costs associated with the arbitration
                proceedings. Notwithstanding the foregoing, the Company may seek
                and obtain injunctive relief in any jurisdiction in any court of
                competent jurisdiction, and you agree that these Terms are
                specifically enforceable by the Company through injunctive
                relief and other equitable remedies without proof of monetary
                damages.
              </p>
              <p>
                14.4. You and Aevo agree that any dispute arising out of or in
                connection with these Terms (including without limitation the
                enforceability of this Section 14 or any question regarding its
                existence, validity or termination, your access or use of the
                App, the Site or the Services) , and that any dispute will be
                resolved solely through individual action, and will not be
                brought as a class arbitration, class action, or any other type
                of representative proceeding.
              </p>
            </span>
          ),
        },
        {
          question: "15. Notices",
          answer: (
            <span>
              <p>
                To give us notice under these Terms, the user must contact the
                Company by email at admin@ribbonlabs.co.
              </p>
            </span>
          ),
        },
        {
          question: "16. Entire Agreement",
          answer: (
            <span>
              <p>
                These Terms constitute the entire legal agreement between you
                and the Company, govern your access to and use of the Site, the
                App or the Services, and completely replace any prior or
                contemporaneous agreements between the parties related to your
                access to or use of the Site, the App or the Services, whether
                oral or written.
              </p>
            </span>
          ),
        },
        {
          question: "17. Force Majeure",
          answer: (
            <span>
              <p>
                The Company shall not be liable for delays, failure in
                performance or interruption of service which result directly or
                indirectly from any cause or condition beyond its reasonable
                control, including but not limited to, significant market
                volatility, any delay or failure due to any act of God, act of
                civil or military authorities, act of terrorists, civil
                disturbance, war, strike or other labour dispute, fire,
                interruption in telecommunications or Internet services or
                network provider services, failure of equipment and/or software,
                other catastrophe or any other occurrence which is beyond its
                reasonable control, and shall not affect the validity and
                enforceability of any remaining provisions.
              </p>
            </span>
          ),
        },
        {
          question: "18. Third party rights",
          answer: (
            <span>
              <p>
                There are no third party beneficiaries to these Terms. A person
                who is not a party under these Terms has no right under any
                applicable law to enforce or to enjoy the benefit of these
                Terms.
              </p>
            </span>
          ),
        },
        {
          question: "19. No agency or partnership",
          answer: (
            <span>
              <p>
                Nothing in these Terms create any agency, partnership, joint
                venture or any similar relationship between the Company and you,
                nor cause the Company and you to be deemed acting in concert in
                any respect.
              </p>
            </span>
          ),
        },
        {
          question: "20. Interpretation",
          answer: (
            <span>
              <p>
                The language in these Terms will be interpreted as to its fair
                meaning, and not strictly for or against any party.
              </p>
            </span>
          ),
        },
        {
          question: "21. Assignment",
          answer: (
            <span>
              <p>
                Nothing in these Terms create any agency, partnership, joint
                venture or any similar relationship between the Company and you,
                nor cause the Company and you to be deemed acting in concert in
                any respect.
              </p>
            </span>
          ),
        },
        {
          question: "22. Illegality",
          answer: (
            <span>
              <p>
                Should any provision or part-provision of these Terms is or
                becomes invalid, illegal or unenforceable in any respect under
                any law of any jurisdiction, it shall be deemed modified to the
                minimum extent necessary to make it valid, legal and
                enforceable; if such modification is not possible, the relevant
                provision or part-provision shall be deemed deleted. Any
                modification to or deletion of a provision or part-provision
                pursuant to this Section 22 shall not affect or impair the
                validity and enforceability of the rest of these Terms, nor the
                validity and enforceability of such provision or part-provision
                under the law of any other jurisdiction.
              </p>
            </span>
          ),
        },
        {
          question: "23. Waiver",
          answer: (
            <span>
              <p>
                Our failure to enforce any provision of these Terms will not be
                deemed a waiver of such provision, nor of the right to enforce
                such provision.
              </p>
            </span>
          ),
        },
        {
          question: "24. Severability",
          answer: (
            <span>
              <p>
                If any provision of these Terms shall be determined to be
                invalid or unenforceable under any rule, law, or regulation of
                any local, state, or federal government agency, such provision
                will be changed and interpreted to accomplish the objectives of
                the provision to the greatest extent possible under any
                applicable law and the validity or enforceability of any other
                provision of these Terms shall not be affected. If such
                construction is not possible, the invalid or unenforceable
                portion will be severed from these Terms but the rest of these
                Terms will remain in full force and effect.
              </p>
            </span>
          ),
        },
        {
          question: "25. Survival",
          answer: (
            <span>
              <p>
                The following provisions of these Terms shall survive
                termination of your use or access to the Site: Sections 5, 9,
                10, 11, 14, and any other provision that by its terms survives
                termination of your use or access to the Site.
              </p>
            </span>
          ),
        },
        {
          question: "26. English Language",
          answer: (
            <span>
              <p>
                Notwithstanding any other provision of these Terms, any
                translation of these Terms is provided for your convenience. The
                meanings of terms, conditions, and representations herein are
                subject to their definitions and interpretations in the English
                language. In the event of conflict or ambiguity between the
                English language version and translated versions of these terms,
                the English language version shall prevail. You acknowledge that
                you have read and understood the English language version of
                these Terms.
              </p>
            </span>
          ),
        },
      ],
    },
  ];
  return { sections };
}

export default Sections;
